import { useGetNetworkAdminsQuery } from 'services/networkAdminV2';
import { useSelector } from 'react-redux';
import { userSelector, activeNetworkSelector } from 'redux/selectors';

import { useGetContactsQuery } from 'services/contactsV2';

export const useNetworkOverview = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const user = useSelector(userSelector);

  const { networkAdminsCount, alliesCount, isLoading } = useGetNetworkAdminsQuery(
    { networkId: activeNetwork.id, includeAllies: true },
    {
      selectFromResult: ({ data }) => ({
        networkAdminsCount: data?.filter((admin) => admin.role === 'network_admin').length ?? 0,
        alliesCount:
          data?.filter((admin) => admin.role === 'ally' && admin.linkedinSyncStatus === 'active').length ?? 0,
      }),
    },
  );

  const { contactsCount, isLoading: isLoadingContacts } = useGetContactsQuery(
    {},
    {
      selectFromResult: ({ data }) => ({
        contactsCount: data?.meta?.contactsTotal ?? 0,
      }),
    },
  );

  const desktopWidth = '1/3';

  return {
    networkAdminsCount,
    alliesCount,
    isLoading,
    contactsCount,
    isLoadingContacts,
    activeNetwork,
    desktopWidth,
    user,
  };
};
